import { useQuery } from "@tanstack/react-query";
import { getInspectionsByShift } from "../../repositories/InspectionRepository";
import { useInspectionUrl } from "../useInspectionUrl";

export const useInspectionByIdQuery = (assetId: number) => {
	const [raw] = useInspectionUrl();
	const id = raw !== null && /^\d+$/.test(raw) ? Number(raw) : NaN;
	const valid = Number.isSafeInteger(id) && id > 0;
	const query = useQuery({
		// Kept outside the "test-shack-inspections" family: saves and deletes must not
		// refetch it. Opening an inspection always refetches (refetchOnMount "always").
		queryKey: ["test-shack-inspection-by-id", assetId, raw],
		enabled: raw !== null && valid,
		retry: false,
		refetchOnMount: "always",
		staleTime: 0,
		queryFn: async ({ signal }) => {
			const result = await getInspectionsByShift(
				{ assetId, profileInspectionId: id },
				signal,
			);
			const inspection = result.inspections.find(
				(row) => row.ProfileInspectionId === id && row.AssetId === assetId,
			);
			if (!inspection)
				throw new Error("Inspection unavailable for this asset.");
			return inspection;
		},
	});
	return {
		// URL changes fetch even cached IDs. Forms accept the completed read only
		// when entering edit mode, so background refreshes cannot replace a draft.
		data:
			raw !== null && valid && !query.isFetching && query.isSuccess
				? query.data
				: undefined,
		error:
			raw === null
				? null
				: !valid
					? "Inspection ID is invalid."
					: !query.isFetching && query.isError
						? "Inspection unavailable for this asset."
						: null,
		requested: raw !== null,
	};
};
